import { IntegrationCountResponse } from '@aibees/elephant/types/integration';
import { useBaseQuery } from '@aibees/shared/http/hooks';
import { useWorkspace } from '@aibees/shared/workspace';
import { INTEGRATION_API_PREFIX } from './constants';

export function useBrowseIntegrationCountApi() {
  const workspace = useWorkspace();
  const params = {
    return: 'count',
  };
  return useBaseQuery<typeof params, IntegrationCountResponse>(
    [useBrowseIntegrationCountApi.name],
    {
      url: INTEGRATION_API_PREFIX.replace(':wid', String(workspace?.id)),
      params,
    }
  );
}
